<template>
	<v-card v-if="add">
					<v-container fluid grid-list-md>
			    		<v-select 
			    		:items="taskTypes"
			    		:label="translater.__('Task type', 'tasks')"
			    		v-model="taskType"
			    		></v-select>
			    	</v-container>
			    	<!--v-container>
		    			<Upload v-if="showUploadForm" />
		    		</v-container-->
			        <!-- Video task needs no content & description -->
		    		
			        <v-card-title primary-title>

			        	<TextTask v-if="taskType == 0" validate-method="checkpointsValidator/validateTextTask"></TextTask>
			        	<TextTask v-if="taskType == 18" validate-method="checkpointsValidator/validateFeedbackTask"></TextTask>
			        	<ImageTask v-if="taskType == 6 || taskType == 15 || taskType == 20 || taskType == 21"></ImageTask>
			        	<AudioTask v-if="taskType == 4"></AudioTask>
			        	<VideoTask v-if="taskType == 7 || taskType == 12 || taskType == 17"></VideoTask>
			        	<Slides v-if="taskType == 13"></Slides>
			        	<SeasonVideoTask v-if="taskType == 14"></SeasonVideoTask>
			        	<YoutubeVideo v-if="taskType == 19"></YoutubeVideo>
			         
			          

				    	
				    	
					    
				    	
				    	
			        </v-card-title>
				   
			        
			    

			        
		    </v-card>
</template>

<script>
	
	
	import TextTask from './TextTask'
	import ImageTask from './ImageTask'
	import Slides from './Slides'
	import AudioTask from './AudioTask'
	import VideoTask from './VideoTask'
	import SeasonVideoTask from './SeasonVideoTask'
	import YoutubeVideo from './YoutubeVideo'

	export default {
		name: 'AddTask',
		components: {
			
			Slides,
			TextTask,
			ImageTask,
			AudioTask,
			VideoTask,
			SeasonVideoTask,
			YoutubeVideo
		},
		data()
		{
			return{}
		},

		methods: {


			store()
			{	

				
				
				if(this.taskType === 0)
				{	
					this.$store.dispatch('checkpoints/storeTask');
				} else if(this.taskType === 6)
				{
					this.$store.dispatch('checkpoints/storeImageTask');
				} else if(this.taskType === 4)
				{
					this.$store.dispatch('checkpoints/storeAudioTask');
				} else if(this.taskType === 7 || this.taskType === 12)
				{
					this.$store.dispatch('checkpoints/storeVideoTask');
				} else if(this.taskType === 13)
				{
					this.$store.dispatch('checkpoints/storeSlides');
				} else if(this.taskType === 14)
				{
					this.$store.dispatch('checkpoints/storeSeasonVideoTask');
				}

				this.$store.dispatch('status/updateResources', 'routedata')
				
			}
		},

		computed:
		{

			valid: {
				get(){
					return false
				}
			},

			add: {
				get()
				{
					return this.$store.getters['checkpoints/add']
				},

				set(value)
				{
					this.$store.dispatch('checkpoints/setAddCheckpoint', value)
				}

			},

			taskTypes: {
				get()
				{
					return this.$store.getters['checkpoints/taskTypes'];
				}
			},

			translater: {
				get()
				{
					return this.$store.getters['translate/translater'];
				}
			},

			taskType: {
				get()
				{
					return this.$store.getters['checkpoints/newTask'].type
				},

				set(value)
				{
					this.$store.dispatch('checkpoints/setNewTaskType', value)

					//this.$store.dispatch('checkpoints/flushNewTask')
				}
			},

			/*showUploadForm: {
				get()
				{
					return this.$store.getters['checkpoints/showUploadForm']
				}
			},*/

			/*newTaskQuestionContent: {
				get()
				{
					return this.$store.getters['checkpoints/newTask'].question.content
				},

				set(value)
				{
					this.$store.dispatch('checkpoints/setNewTaskQuestionContent', value)
				}
			}, 
			
			newTaskQuestionDescription: {
				get()
				{
					return this.$store.getters['checkpoints/newTask'].question.description;
				},

				set(value)
				{
					this.$store.dispatch('checkpoints/setNewTaskQuestionDescription', value)
				}
			}, */

			answersRequired:{
				get()
				{
					return this.$store.getters['checkpoints/answersRequired'];
				}
			}
		}
	}
</script>